import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { useRouter } from 'next/router';
import clsx from 'clsx';

import { ArrowRightIcon } from '@components/icons/ArrowRightIcon';
import { CalendarIcon } from '@components/icons/CalendarIcon';
import Image from '@components/elements/Image';

import styles from './ArticleCard.module.css';

/**
 * @param props
 * @param {string} props.title
 * @param {string} props.previewImageUrl
 * @param {string} props.previewText
 * @param {string} date
 * @param {string} link
 *
 * @returns {JSX.Element}
 * */
export function ArticleCard({
  title,
  previewImageUrl,
  previewText,
  date,
  link,
}) {
  const { t: tt } = useTranslation('blog');
  const { t: tBlog } = useTranslation('blog');

  const router = useRouter();

  return (
    <Link
      href={link}
      className={clsx(
        styles.card,
        'flex flex-col block max-w-sm overflow-hidden bg-[#151719]',
        'border border-[#2B6EFF] rounded-xl pb-6',
        'transform transition duration-300',
        'hover:delay-200 hover:scale-105',
        'focus:scale-105',
      )}
      locale="en"
      prefetch={false}
    >
      <div className="relative">
        <img
          src={previewImageUrl}
          alt="Article's preview image"
          height={700}
          width={700}
          className="rounded-mb-xl"
        />
      </div>

      <div className="flex flex-col gap-1 items-center justify-center">
        <div className="text-[12px] flex flex-row gap-1 mt-1">
          <CalendarIcon size={15} />
          <time>{date}</time>
        </div>
        <h2 className="text-[18px] m-0 leading-[22px] font-semibold text-white px-[8px]">
          {tBlog(title)}
        </h2>
        <h5 className="text-[14px] pb-3 leading-normal font-normal text-white/80 mx-2 mt-0">
          {tBlog(previewText)}
        </h5>
        <span className="text-red-600 text-[14px] flex flex-row gap-1 fixed bottom-3 ">
          {tt('details.link')}
          <ArrowRightIcon color="red" size={15} />
        </span>
      </div>
    </Link>
  );
}
